import { Chip, makeStyles } from "@material-ui/core";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "../../../../Common/Select";

interface CustomSelectProps {
  id: string;
  label: string;
  options: { id: string; name: string }[];
  value: any[];
}

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: 2,
  },
  selectField: {
    "& .MuiInput-underline:before": {
      borderBottomStyle: "solid",
      borderBottomColor: "#949494",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomStyle: "solid",
      borderBottomColor: "#949494",
    },
    "& .MuiInput-underline:after": {
      borderBottomStyle: "solid",
      borderBottomColor: "#000000",
    },
  },
}));

const CustomSelect: FC<CustomSelectProps> = ({ id, label, options, value }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Select
      className={classes.selectField}
      id={id}
      label={t(label)}
      options={options}
      disabled
      setValue={() => {}}
      fullWidth
      value={value}
      multiple={true}
      renderTags={(values: any) =>
        values.map((option: any, index: any) => (
          <span>
            <Chip
              className={classes.chip}
              key={index}
              variant="outlined"
              label={option.name}
            />
          </span>
        ))
      }
    />
  );
};

export default CustomSelect;
